import get from 'lodash.get';
import BreadCrumb from '../breadcrumb';
import amcStyles from '../../styles/amcs.scss';
import SingleFundTitleNew from './singleFundTitleNew';
import {
  ELSS,
  FundOverView,
  FundPerformanceChart,
  NfoOverview,
  Holdings,
  ReturnCalculator,
  TopSectors,
  RelatedFunds,
  KeyRatio,
  InvestNow,
} from '../singleFundNewCmp';
import { formatRupeeLiteral } from '../../constants';

import { AboutFund } from '../singleFundNewCmp/aboutFund';
import TestimonialsSection from '../homePageNew/testimonial';
import { SECTION_TESTIMONIALS } from '../../constants/homeConstantsNew';
import WhyCleartaxNew from '../plan/whyCleartaxNew';
import { SubHeading } from '../common/subHeading';
import { StepsToInvest } from '../singleFundNewCmp/stepsToInvest/index';
import FAQNew from '../plan/faqNew';
import { InvestAmount } from '../singleFundNewCmp/investAmount';
import { toTitleCase } from '../../utils';
import { calculateAge, formatEpochToDateString } from '../../utils/commonUtils';

const returnsArr = {
  return1yr: 'return1Y',
  return2yr: 'return2Y',
  return3yr: 'return3Y',
  return4yr: 'return4Y',
  return5yr: 'return5Y',
  return6yr: 'return6Y',
  return7yr: 'return7Y',
  return8yr: 'return8Y',
  return9yr: 'return9Y',
  return10yr: 'return10Y',
  returnSinceInception: 'returnALL',
};
const returnCategoryMap = {
  return1yr: 'return1Y',
  return2yr: 'return2Y',
  return3yr: 'return3Y',
  return4yr: 'return4Y',
  return5yr: 'return5Y',
  return10yr: 'return10Y',
};
export const optimizeFundData = (fund: any) => {
  const { category, collapsibleInfo, returns, returnsCategory } = fund;
  let sectors = get(collapsibleInfo, 'holdingsSector.sectors', []);
  if (sectors && sectors.length) {
    sectors = sectors.map((ele) => ({
      ...ele,
      y: ele.weightage,
      name: ele.type,
    }));
  }
  return {
    ...fund,
    isElss: category === 'ELSS' ? true : false,
    sectors,
    holdings: get(collapsibleInfo, 'holdingsSector.holdings', []),
    faqs: get(collapsibleInfo, 'faqs.faqs', []),
    insights: get(collapsibleInfo, 'insights', []),
    fundManagers: get(collapsibleInfo, 'fundManagerAndAMC.fundManager', []),
    amcDetail: get(collapsibleInfo, 'fundManagerAndAMC.amc', {
      name: '',
      description: '',
      custodian: '',
      addressLine1: '',
      addressLine2: '',
      fax: '',
      phone: '',
      website: '',
    }),
    ...(returns && returnsCategory && getReturns(returns, returnsCategory)),
    ...(fund.info && getInfoValues(fund.info)),
    breadcrumbs: getBreadCrumbs(fund || {}),
    ...(fund.nfoDetails && getDates(fund.nfoDetails)),
  };
};

const getReturns = (returns, returnsCategory) => {
  const newReturns = {};
  const newReturnCategory = {};
  Object.keys(returnsArr).forEach((ele) => {
    newReturns[ele] = returns[returnsArr[ele]]
      ? returns[returnsArr[ele]]
      : null;
  });
  Object.keys(returnCategoryMap).forEach((ele) => {
    newReturnCategory[ele] = returnsCategory[returnCategoryMap[ele]]
      ? returnsCategory[returnCategoryMap[ele]]
      : null;
  });
  return {
    returns: { ...returns, ...newReturns },
    returnsCategory: { ...newReturnCategory, ...returnsCategory },
  };
};

const getInfoValues = (info) => {
  const infoData: any = {};
  const score = info.filter((ele) => ele.key === 'Morningstar');
  infoData.lockInPeriod = get(
    info.filter((ele) => ele.key === 'Lock-in'),
    '[0].value',
    ''
  );
  infoData.risk = get(
    info.filter((ele) => ele.key === 'Risk'),
    '[0].value',
    ''
  );
  infoData.expenseRatio = get(
    info.filter((ele) => ele.key === 'Expense Ratio'),
    '[0].value',
    ''
  );
  if (score && score[0] && score[0].value) {
    infoData.morningStar =
      score[0].value === 'Not Rated' ? '0' : score[0].value;
  }
  return infoData;
};

const getBreadCrumbs = (fund: any) => {
  const { issuingAuthority, parentSlug, fundLegalName, slug, name } = fund;
  return [
    {
      link: '/mutual-funds',
      text: 'Mutual funds',
    },
    {
      text: 'Fund Houses',
      link: `/mutual-funds/catalogue`,
    },
    {
      text: issuingAuthority ? toTitleCase(issuingAuthority) : '',
      link: `/mutual-funds/${parentSlug}`,
    },
    {
      text: name ? name : fundLegalName,
      link: `/mutual-funds/${parentSlug}/${slug}`,
    },
  ];
};

const getDates = (details: any) => {
  const closeDate = changeDateFormat(details.closeDate);
  const allotmentDate = changeDateFormat(details.allotmentDate);
  const openDate = changeDateFormat(details.openDate);
  return {
    nfoCloseDate:
      closeDate && closeDate.length
        ? `${closeDate[2]} ${closeDate[1]} ${closeDate[3]}`
        : '',
    nfoCloseDay: closeDate && closeDate.length ? `${dayMap[closeDate[0]]}` : '',
    allotmentDate:
      allotmentDate && allotmentDate.length
        ? `${allotmentDate[2]} ${allotmentDate[1]}`
        : '',
    openDate:
      openDate && openDate.length ? `${openDate[2]} ${openDate[1]}` : '',
  };
};
/* This will change the format in dd mmm yyyy */
const changeDateFormat = (date: any) => {
  if (date && new Date(date) instanceof Date) {
    const dateArr = date.split('/');
    const temp = dateArr[0];
    dateArr[0] = dateArr[1];
    dateArr[1] = temp;
    const a = new Date(dateArr.join('/'));
    const newDate = a.toDateString();
    return newDate.split(' ');
  } else {
    return [];
  }
};

export const dayMap = {
  Mon: 'Monday',
  Tue: 'Tuesday',
  Wed: 'Wednesday',
  Thu: 'Thursday',
  Fri: 'Friday',
  Sat: 'Saturday',
  Sun: 'Sunday',
};

export const COMPONENT_MAP = [
  {
    component: (props) => (
      <div className="lil-container">
        <BreadCrumb {...props} linkStyles={amcStyles['breadcrumb-link']} />
      </div>
    ),
    key: 'random8',
    stateProps: [{ breadcrumbs: ['optimizedFund.breadcrumbs', []] }],
  },
  {
    key: 'random7',
    component: ({ children }) => (
      <div className="lil-flex lil-container  md:lil-items-start  sm:lil-pb-0 sm:lil-flex-col">
        {children}
      </div>
    ),
    childComponent: [
      {
        component: ({ children }) => (
          <div className="lil-w-2/3 sm:lil-w-full">{children}</div>
        ),
        key: 'random6',
        childComponent: [
          {
            component: SingleFundTitleNew,
            stateProps: [
              {
                title: [
                  'optimizedFund.name',
                  'optimizedFund.fundLegalName',
                  '',
                ],
              },
              { isNfo: ['optimizedFund.isNfo', ''] },
              { morningStar: ['optimizedFund.morningStar', ''] },
              { imgURL: ['optimizedFund.image', ''] },
              { purchaseMode: ['optimizedFund.purchaseMode', ''] },
              { planType: ['optimizedFund.planType', ''] },
              { isElss: ['optimizedFund.isElss', ''] },
              { selectedTimePeriod: ['selectedTimePeriod', '3Y'] },
              { returns: ['optimizedFund.returns', {}] },
              { navArr: ['optimizedFund.latestNav', {}] },
              {
                returnsSinceInception: ['optimizedFund.returns.returnALL', ''],
              },
              { risk: ['optimizedFund.risk', ''] },
              { category: ['optimizedFund.category', ''] },
              { name: ['optimizedFund.name', ''] },
            ],
            fnProps: [
              {
                key: 'returnsLabelArr',
                value: 'returnArr',
                parameters: ['optimizedFund.returns', 'state'],
                defaultValue: {},
              },
            ],
            key: 'random5',
          },

          {
            component: ELSS,
            stateProps: [
              'title',
              { isNfo: ['optimizedFund.isNfo', []] },
              { imgURL: ['optimizedFund.image', ''] },
            ],
            fnProps: [
              {
                key: 'returnsLabelArr',
                value: 'returnArr',
                parameters: ['optimizedFund.returns', 'state'],
                defaultValue: {},
              },
            ],
            conditionalRender: ['optimizedFund.isElss', 'state'],
            key: 'random3',
          },
          {
            component: FundPerformanceChart,
            key: 'FundPerformancChart',
            stateProps: [
              {
                fundPerformaceData: [
                  'optimizedFund.fundPerformaceData.all',
                  [],
                ],
              },
              {
                catgPerformaceData: [
                  'optimizedFund.catgPerformaceData.all',
                  [],
                ],
              },
              { category: ['optimizedFund.category', []] },
              { name: ['optimizedFund.name', ''] },
            ],
            fnProps: ['handleTimePeriodChange'],
            conditionalRender: [
              'optimizedFund.fundPerformaceData.all',
              'state',
            ],
          },
          {
            component: NfoOverview,
            stateProps: [
              { nfoState: ['optimizedFund.nfoDetails', ''] },
              { nfoCloseDate: ['optimizedFund.nfoCloseDate', ''] },
              { nfoCloseDay: ['optimizedFund.nfoCloseDay', ''] },
              { nav: ['optimizedFund.nav', ''] },
              { allotmentDate: ['optimizedFund.allotmentDate', ''] },
              { openDate: ['optimizedFund.openDate', ''] },
            ],
            conditionalRender: ['optimizedFund.isNfo', 'state'],
          },

          {
            component: FundOverView,
            stateProps: [{ fundData: ['optimizedFund', {}] }],
            props: ['isMobile'],
          },
          {
            component: ({ children }) => (
              <div
                className={`lil-w-full lil-pl-12 lil-pt-12 md:lil-pt-6 sm:lil-pt-4  xl:lil-hidden lg:lil-hidden md:lil-hidden sm:lil-p-0`}
              >
                {children}
              </div>
            ),
            childComponent: [
              {
                component: InvestAmount,
                stateProps: [
                  { data: ['optimizedFund', {}] },
                  'investmentType',
                  'amount',
                  'minAmount',
                  'maxAmount',
                  'investInView',
                  'callbackRequested',
                  'isMaxAmountExceed',
                  'isMonthlyLimitExceed',
                ],
                fnProps: [
                  'visibilityChange',
                  'onChange',
                  'onAmountChangeBlur',
                  'investClick',
                  'callback',
                  'dismissModal',
                  'getSelectedAmt',
                ],
                props: ['hasUserInvestedInProduct', 'userInfo'],
                key: 'random10',
              },
            ],
            key: 'random9',
            conditionalRender: ['optimizedFund', 'state'],
          },
          {
            component: Holdings,
            stateProps: [{ holdings: ['optimizedFund.holdings', []] }],
            fnProps: ['investClick'],
            conditionalRender: ['optimizedFund.holdings', 'state'],
          },
          {
            component: ReturnCalculator,
            stateProps: [
              { returns: ['optimizedFund.returns', []] },
              { returnsCategory: ['optimizedFund.returnsCategory', []] },
            ],
            conditionalRender: ['optimizedFund.returns', 'state'],
          },
          {
            component: TopSectors,
            stateProps: [{ sectors: ['optimizedFund.sectors', []] }],
            conditionalRender: ['optimizedFund.sectors', 'state'],
          },
          {
            props: ['isMobile'],
            component: RelatedFunds,
            stateProps: [{ similarFunds: ['optimizedFund.similarFunds', []] }],
            conditionalRender: ['optimizedFund.similarFunds', 'state'],
          },
          {
            component: KeyRatio,
            stateProps: [{ insights: ['optimizedFund.insights.insights', []] }],
            conditionalRender: ['optimizedFund.insights.insights', 'state'],
          },
          {
            component: AboutFund,
            stateProps: [
              {
                fundManagers: [
                  'optimizedFund.collapsibleInfo.fundManagerAndAMC.fundManager',
                  [],
                ],
              },
              {
                amcDetail: [
                  'optimizedFund.collapsibleInfo.fundManagerAndAMC.amc',
                  {},
                ],
              },
            ],
            conditionalRender: [
              'optimizedFund.collapsibleInfo.fundManagerAndAMC',
              'state',
            ],
          },
          {
            component: TestimonialsSection,
            constantProps: { SECTION_TESTIMONIALS, wrapperClass: 'lil-w-2/3' },
          },
        ],
      },
      {
        component: ({ children }) => (
          <div
            className={`lil-w-1/3 lil-pl-12 lil-pt-12 md:lil-pt-6 sm:lil-pt-4  sm:lil-hidden sm:lil-p-0 ${amcStyles['stickyRight']}`}
          >
            {children}
          </div>
        ),
        childComponent: [
          {
            component: InvestAmount,
            stateProps: [
              { data: ['optimizedFund', {}] },
              'investmentType',
              'amount',
              'minAmount',
              'maxAmount',
              'investInView',
              'callbackRequested',
              'isMaxAmountExceed',
              'isMonthlyLimitExceed',
            ],
            fnProps: [
              'visibilityChange',
              'onChange',
              'onAmountChangeBlur',
              'investClick',
              'callback',
              'dismissModal',
              'getSelectedAmt',
            ],
            props: ['hasUserInvestedInProduct', 'userInfo'],
          },
        ],
        conditionalRender: ['optimizedFund', 'state'],
        key: 'random1',
      },
    ],
  },

  {
    component: WhyCleartaxNew,
    constantProps: { Heading: SubHeading, title: 'Why Invest with ClearTax' },
  },
  {
    component: StepsToInvest,
  },

  {
    component: FAQNew,
    stateProps: [{ faqs: ['optimizedFund.faqs', []] }],
    conditionalRender: ['optimizedFund.faqs', 'state'],
  },
  {
    component: InvestNow,
    fnProps: ['investClicked'],
    conditionalRender: ['showStickyInvest', 'state'],
    key: 'random2',
  },
];

export const StepsToInvestArr = [
  {
    img: 'https://assets1.cleartax-cdn.com/cleartax/images/1606245906_onboarding.svg',
    heading: 'Select the amount to invest',
    subHeading: 'Choose from 200+ mutual funds catered for you',
  },
  {
    arrow: true,
    img: 'https://assets1.cleartax-cdn.com/cleartax/images/1605952657_arrowdown.svg',
  },
  {
    img: 'https://assets1.cleartax-cdn.com/cleartax/images/1605686738_invoiceuploaded.svg',
    heading: 'Enter personal details',
    subHeading: 'Complete your KYC and get registered',
  },
  {
    arrow: true,
    img: 'https://assets1.cleartax-cdn.com/cleartax/images/1605952657_arrowdown.svg',
  },
  {
    img: 'https://assets1.cleartax-cdn.com/cleartax/images/1605686593_tradevaluefiled.svg',
    heading: ' Pay and your are done!',
    subHeading: 'Checkout and see your money grow',
  },
];

export const fundOverviewData = (fundData) => {
  return [
    {
      heading: 'Rating',
      data: `${
        fundData.morningStar !== '0'
          ? fundData.morningStar + ' Star'
          : 'No Rating'
      }`,
    },
    {
      heading: 'Expense ratio',
      data: `${fundData.expenseRatio}${
        fundData.expenseRatioDate
          ? ` as on ${formatEpochToDateString(fundData.expenseRatioDate)}`
          : ''
      }`,
    },
    {
      heading: 'Exit Load',
      data:
        fundData && fundData.exitLoadDetail
          ? `${fundData.exitLoadDetail.percentage}% within ${fundData.exitLoadDetail.days} days`
          : '',
    },
    {
      heading: 'AUM (Fund size)',
      data: `₹${formatRupeeLiteral(fundData.aum)}`,
    },
    {
      heading: 'Lock-in period',
      data: `${fundData.lockInPeriod}`,
    },
    ...(fundData.inceptionDate !== null
      ? [
          {
            heading: 'Age',
            data: `${calculateAge(
              fundData.inceptionDate
            )} yrs since ${formatEpochToDateString(fundData.inceptionDate)}`,
          },
        ]
      : []),
    ...(fundData.fundBenchmark !== null
      ? [
          {
            heading: 'Benchmark',
            data: `${fundData.fundBenchmark}`,
          },
        ]
      : []),
    {
      heading: 'Min. investment',
      data: `SIP ₹${fundData.minSipAmount} & Lump. ₹${fundData.minAmount}`,
    },
    {
      heading: 'Risk',
      data: fundData.risk,
    },
    ...(fundData.category && fundData.category.toLowerCase() === 'debt'
      ? [
          {
            heading: 'Tax implications',
            data: 'Short-term capital gains (STCG) are taxed at applicable slab rates',
          },
        ]
      : [
          {
            heading: 'Short-term capital gains (STCG)',
            data: 'Returns taxed at 20% if you redeem before 1 year',
          },
          {
            heading: 'Long-term capital gains (LTCG)',
            data: 'After 1 year, pay tax of 12.5% on returns of ₹1.25 lakh+ in a financial year',
          },
        ]),
  ];
};

export const nfoOverviewData = (fundData) => {
  let expenseRatio = '-';
  if (fundData.expenseRatio !== '-') {
    expenseRatio = `${fundData.expenseRatio}`;
  }
  return [
    {
      heading: 'Expense ratio',
      image:
        'https://assets1.cleartax-cdn.com/cleartax/images/1631786033_wallet.svg',
      data: `${expenseRatio}`,
    },
    {
      heading: 'Exit Load',
      image:
        'https://assets1.cleartax-cdn.com/cleartax/images/1631785982_calculator.svg',
      data:
        fundData && fundData.exitLoadDetail
          ? `${fundData.exitLoadDetail.percentage}% in ${fundData.exitLoadDetail.days} days`
          : '',
    },
    {
      heading: 'Lock-in period',
      image:
        'https://assets1.cleartax-cdn.com/cleartax/images/1631785822_lockkey.svg',
      data: `${fundData.lockInPeriod}`,
    },

    {
      heading: 'Risk',
      image:
        'https://assets1.cleartax-cdn.com/cleartax/images/1631786077_gauge.svg',
      data: fundData.risk,
    },
  ];
};



// WEBPACK FOOTER //
// ./components/singleFund/singleFundConst.tsx